import axios from 'axios';

import { asyncHttpReqEnded, asyncHttpReqStarted } from '@store/common/actions';

import store from '../store';
import { addCustomerIdInterceptors } from './axiosInstance';
import axiosConfig from './config';

const instance = axios.create(axiosConfig);
// legacy Integration for backend
axios.defaults.params = { mode: 'Integration'.toLocaleLowerCase() };

/**
 * handle 400 ~ 500 status
 * @status number
 */
function handle40x(status: number) {
  switch (status) {
    case 403:
      window.location.href = '/login';
      break;
    default:
      break;
  }
}
const requestTiming = {};

function onRequestIntercept(config) {
  requestTiming[config.headers['x-cvv-trace-id']] = Date.now();
  store.dispatch(asyncHttpReqStarted());
  return config;
}

function onResponseIntercept(response) {
  const requestId = response.config.headers['x-cvv-trace-id'];
  const start = requestTiming[requestId];
  if (start) {
    const end = Date.now();
    response.data.duration = end - start;
    delete requestTiming[requestId];
  }
  store.dispatch(asyncHttpReqEnded());
  return response;
}

function handleError(error) {
  const {
    response: { status },
  } = error;
  handle40x(status);
  store.dispatch(asyncHttpReqEnded());
  return Promise.reject(error);
}

instance.interceptors.request.use(onRequestIntercept, handleError);

instance.interceptors.response.use(onResponseIntercept, handleError);

addCustomerIdInterceptors(instance);

export default instance;
export { axiosConfig };
